// HEB-2 — the ONE locale-aware date/time formatter. Reuses HEB-1's established mechanism verbatim:
// Intl.DateTimeFormat keyed on the active i18n language (he → "he-IL", else "en-US"), exactly as
// MiraLauncher's formatDateTime does — no second/divergent pattern. Pass i18n.language through.
//
// NOTE (week-start): Israel's week starts on Sunday, same as the existing Sun-first month grid, so
// no week-start reordering is needed for he-IL — only the weekday HEADER labels localize.
function localeFor(language) {
  return String(language || "").split("-")[0] === "he" ? "he-IL" : "en-US";
}

// CAL-1 — the ONE resolver for which timezone event times DISPLAY in. Storage is always UTC ISO;
// the display tz is the user's explicit `timezone` if set, else the BROWSER's local zone. The old
// `|| "UTC"` fallback is the bug: a viewer in Israel (UTC+3) saw 09:00 events render as 06:00. No
// tz-preference feature — browser-local is the display tz.
export function resolveDisplayTimeZone(user) {
  const explicit = user && typeof user.timezone === "string" ? user.timezone.trim() : "";
  if (explicit) return explicit;
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export function formatDate(value, language, options = { dateStyle: "medium" }) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(localeFor(language), options).format(d);
}

export function formatTime(value, language, options = { hour: "2-digit", minute: "2-digit" }) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(localeFor(language), options).format(d);
}

export function formatDateTime(value, language, options = { dateStyle: "medium", timeStyle: "short" }) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(localeFor(language), options).format(d);
}
